<div class="date-locations-form-wrapper" [formGroup]="scheduleGroup" [ngStyle]="{ width }">
  <div class="date-locations-form-col" *ngIf="rows == 2">
    <ng-container *ngIf="(locations?.length !== preSelectedLocs?.length)" [ngTemplateOutlet]="selectLocations"></ng-container>
    <ng-container *ngIf="preSelectedLocs?.length" [ngTemplateOutlet]="selectedLocations"></ng-container>
  </div>

  <!-- <div class="schedule_date">
    <div class="date-locations-form-col schedule_later" *ngIf="scheduleGroup.controls['checked']?.value">
      <div class="date-locations-form-row date">
        <div class="grid-item">Date</div>
        <div class="grid-item">
          <p-calendar [style]="{ minWidth: '100%' }" formControlName="date" [showIcon]="true" inputId="icon"
            dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" [disabled]="disableScheduleForLaterSwitch"></p-calendar>
        </div>
      </div>
      <div class="date-locations-form-row time">
        <div class="grid-item">Time</div>
        <div class="grid-item">
          <p-calendar [style]="{ minWidth: '100%' }" formControlName="time" [timeOnly]="true" [hourFormat]="12"
            inputId="timeonly" placeholder="00:00 PM" [disabled]="disableScheduleForLaterSwitch"></p-calendar>
        </div>
      </div>
      <div class="date-locations-form-row time_zone">
        <div class="grid-item">Time Zone</div>
        <div class="grid-item">
          <p-dropdown [style]="{ minWidth: '100%' }" [options]="timeZones" [group]="true" optionLabel="name"
            optionValue="value" formControlName="timeZone" placeholder="Select"  tooltipPosition="top" [disabled]="disableScheduleForLaterSwitch"></p-dropdown>
        </div>
      </div>
      <ng-container *ngIf="rows == 1" [ngTemplateOutlet]="selectLocations"></ng-container>
    </div>
  </div> -->
</div>

<ng-template #selectLocations [formGroup]="scheduleGroup">
  <div class="date-locations-form-row">
    <div class="grid-item loc_title">{{ preSelectedLocs.length ? 'Add new lcoations' : 'Locations' }}</div>
    <div class="grid-item select-all">
      <p-checkbox formControlName="isSelectedAll" [binary]="true" inputId="binary" (onChange)="handleAllLocChange($event)" [disabled]="showFilteredLocationsDropdown"></p-checkbox>
      <span>Select all
        <b *ngIf="preSelectedLocs.length">unselected </b>
        <b>({{ totalLocationsCount || locations.length }})</b>
        locations</span>
      <span class="material-icons-outlined" [pTooltip]="'Use the search tool to select/unselect specific location(s)'"
        [tooltipPosition]="'bottom'">
        info
      </span>
      <button pButton type="button" label="Create Location Filter" class="p-button-secondary" 
        (click)="onCreateLocationFilter()" [disabled]="scheduleGroup.controls.isSelectedAll.value"
        [style]="{ marginLeft: '10px', minWidth: 'auto' }"></button>
      <button *ngIf="showFilteredLocationsDropdown" pButton type="button" label="Clear Filter" class="p-button-warning" 
        (click)="clearLocationFilters()"
        [style]="{ marginLeft: '10px', minWidth: 'auto' }"></button>
    </div>
    
    <!-- Filtered Locations Dropdown -->
    <div *ngIf="showFilteredLocationsDropdown" class="date-locations-form-row" style="margin-top: 15px;">
      <div class="grid-item loc_title">Filtered Locations ({{ filteredLocations.length }})</div>
      <div class="grid-item">
        <p-multiSelect 
          [options]="getFilteredLocationsForDisplay()" 
          appendTo="body" 
          [ngModel]="selectedFilteredLocationsForDisplay"
          [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onFilteredLocationsChange($event)"
          optionLabel="displayText" 
          [selectedItemsLabel]="'{0} locations selected'"
          [showHeader]="false" 
          maxSelectedLabels="0"
          [style]="{ minWidth: '100%' }"
          placeholder="Click to view filtered locations">
        </p-multiSelect>
      </div>
    </div>

    <!-- <div class="schedule_now" [class.disable]="disableScheduleForLaterSwitch">
      <span class="schedule_now_title">Schedule for later</span>
      <p-inputSwitch formControlName="checked" [disabled]="disableScheduleForLaterSwitch" (onChange)="hendleScheduleLater()"></p-inputSwitch>
    </div> -->
  </div>
</ng-template>

<ng-template #selectedLocations>
  <div class="date-locations-form-row">
    <div class="grid-item loc_title">Locations</div>
    <div class="grid-item">
      <p-multiSelect [options]="preSelectedLocs" appendTo="body" [ngModel]="preSelectedLocs"
        optionLabel="businessName" [selectedItemsLabel]="'{0} locations selected'"
        [showHeader]="false" maxSelectedLabels="0">
        <ng-template let-location pTemplate="item">
          <div>
            {{ location['storeCode'] }} - {{ location['businessName'] }} - {{ location['city'] }}, {{ location['state']
            }}
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
  </div>
</ng-template>

<!-- Location Filter Modal -->
<div *ngIf="showLocationFilterModal" class="modal-backdrop" (click)="closeModalOnBackdrop($event)">
  <div class="modal" (click)="$event.stopPropagation()">
    <div style="background-color: #d9d9d9; padding: 20px; border-radius: 5px">
      <div style="display:flex; align-items:center; justify-content:space-between; gap: 12px;">
        <div style="font-size: 24px">Location Filter</div>

        <!-- AND / OR toggle -->
        <button
          pButton
          class="p-button-rounded p-button-text"
          type="button"
          (click)="toggleBooleanMode()"
          [label]="isAndMode ? 'AND' : 'OR'"
          [ngClass]="{ 'p-button-success': isAndMode, 'p-button-secondary': !isAndMode }"
          pTooltip="Switch between AND / OR across selected filters"
          tooltipPosition="left"
        ></button>
      </div>

      <!-- Exclusive mode helper text -->
      <div *ngIf="hasStoreCodeFilter" class="p-2" style="color:#900000;">
        <i class="pi pi-info-circle"></i>
        Store Code filter is active. Other filters are disabled until you clear the Store Code(s).
      </div>
      <div *ngIf="hasOtherFilters" class="p-2" style="color:#900000;">
        <i class="pi pi-info-circle"></i>
        Other filters are active. Store Code filter is disabled until you clear other selections.
      </div>

      <!-- Filter Categories -->
      <div *ngFor="let cat of filterCategories; trackBy: trackCatByKey" class="filter-category">
        <h3 (click)="cat.expanded = !cat.expanded" class="category-title">
          {{ cat.label }}
          <i class="pi pi-chevron-down arrow" [style.transform]="cat.expanded ? 'rotate(180deg)' : 'none'"></i>
        </h3>

        <div *ngIf="cat.expanded" class="options-list">
          <!-- Single Select All block - whole row is clickable -->
          <label
            class="row-input-all filter-row-label"
            [attr.for]="'filter-all-' + cat.key"
            [class.filter-row-disabled]="cat.key === 'storeCode' ? hasOtherFilters : hasStoreCodeFilter"
          >
            <input
              type="checkbox"
              [id]="'filter-all-' + cat.key"
              [checked]="isAllSelected(cat.key)"
              (change)="toggleSelectAll(cat.key, $event.target.checked)"
              [disabled]="cat.key === 'storeCode' ? hasOtherFilters : hasStoreCodeFilter"
            />
            <strong>Select All</strong>
          </label>

          <!-- Single options block - whole row is clickable -->
          <label
            *ngFor="let option of cat.options; trackBy: trackOption; let i = index"
            class="row-input filter-row-label"
            [attr.for]="'filter-opt-' + cat.key + '-' + i"
            [class.filter-row-disabled]="cat.key === 'storeCode' ? hasOtherFilters : hasStoreCodeFilter"
          >
            <input
              type="checkbox"
              [id]="'filter-opt-' + cat.key + '-' + i"
              [value]="option"
              [checked]="isSelected(cat.key, option)"
              (change)="onSelectFilter(cat.key, $event.target.checked, option)"
              [disabled]="cat.key === 'storeCode' ? hasOtherFilters : hasStoreCodeFilter"
            />
            <span class="filter-option-text">{{ option }}</span>
          </label>
        </div>
        <p-divider
          *ngIf="cat.key === 'storeCode'"
          align="center"
          styleClass="filter-divider"
        >
          <b>Other filters</b>
        </p-divider>
      </div>
    </div>

    <!-- Buttons -->
    <div class="modal-actions">
      <button pButton class="p-button-danger actions_btn" (click)="cancelFilters()">Close</button>
      <button pButton class="p-button-secondary actions_btn" (click)="clearAllFilters()">Clear all</button>
      <button pButton class="p-button-success actions_btn" [label]="applyFiltersLoading ? 'Loading...' : 'Apply'" [disabled]="applyFiltersLoading" (click)="applyFilters()"></button>
    </div>
  </div>
</div>
